import React from 'react';

const Footer = ({ onShowPrivacy, onShowTerms, onSearch, onShowFAQ }) => (
  <footer style={{ padding: '6rem 0 3rem', background: 'rgba(0,0,0,0.5)', borderTop: '1px solid rgba(255,255,255,0.05)', marginTop: '4rem' }}>
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(180px, 100%), 1fr))', gap: '3rem', marginBottom: '4rem' }}>
        <div>
          <div style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.85rem' }}>
            <img src="/favicon.png" style={{ height: '44px', width: 'auto' }} alt="Logo" />
            <span style={{ fontSize: '1.4rem', fontWeight: 900, letterSpacing: '1px' }}>
              CITA<span style={{ color: 'var(--primary)' }}>DOS</span>
            </span>
          </div>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.6 }}>
            La plataforma líder para conectar jugadores y equipos de fútbol amateur en Argentina.
          </p>
        </div>
        <div>
          <h4 style={{ marginBottom: '1.5rem', fontSize: '1.1rem' }}>Plataforma</h4>
          <ul style={{ listStyle: 'none', padding: 0, color: 'var(--text-muted)', fontSize: '0.9rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li onClick={onSearch} style={{ cursor: 'pointer' }}>Buscar Players</li>
            <li onClick={onSearch} style={{ cursor: 'pointer' }}>Buscar Equipos</li>
            <li onClick={onSearch} style={{ cursor: 'pointer' }}>Armar Partido</li>
            <li onClick={onShowFAQ} style={{ cursor: 'pointer', color: 'var(--primary)' }}>Preguntas Frecuentes</li>
          </ul>
        </div>
        <div>
          <h4 style={{ marginBottom: '1.5rem', fontSize: '1.1rem' }}>Legales</h4>
          <ul style={{ listStyle: 'none', padding: 0, color: 'var(--text-muted)', fontSize: '0.9rem', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
            <li onClick={onShowPrivacy} style={{ cursor: 'pointer', color: 'var(--text-muted)' }}>Política de Privacidad</li>
            <li onClick={onShowTerms} style={{ cursor: 'pointer', color: 'var(--text-muted)' }}>Términos y Condiciones</li>
          </ul>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '2rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
        © 2026 Citados. Todos los derechos reservados.
      </div>
    </div>
  </footer>
);

export default Footer;
